import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'
import i18next from 'i18next'
import { formatDate } from '../Transactions/TransactionsTable'
import { getCostCenter } from '../../store/slices/CostCenterSlice'

export default function ViewReceiptVoucherPage () {
  const location = useLocation()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const lang = i18next.language
  const receiptVoucher = location?.state?.voucher || null
  const { costCenters } = useSelector(state => state?.costCenter)

  useEffect(() => {
    dispatch(getCostCenter())
  }, [dispatch])

  const costCenterName = (voucher) => {
    const center = costCenters?.data?.find(center => center?.id === voucher?.cost_center_id)
    return lang === 'ar' ? center?.name_ar : center?.name_en
  }

  const viewVoucherColumns = [
    { field: 'date', header: t('date'), body: rowData => formatDate(rowData?.date) },
    { field: 'total_amount', header: t('total_amount'), body: rowData => `${rowData?.total_amount} ${t('SAR')}` },
    // { field: 'notes', header: t('description') },
    { header: t('costCenter'), body: row => costCenterName(row) }
  ]

  if (!receiptVoucher) {
    return (
      <div className='p-6'>
        <PageHeader title={t('receipt_voucher_details')} backPath={'/manager/receipt/voucher'} />
        <p className='mt-4'>{t('No_voucher_selected')}</p>
        <div className='mt-4'></div>
      </div>
    )
  }

  const data = [receiptVoucher]
  const detailData = receiptVoucher.details || []

  const detailColumns = [
    { field: 'detail_id', header: t('no') },
    { field: 'account_id', header: t('account') },
    // { field: 'description', header: t('description') },
    { field: 'amount', header: t('amount'), body: row => `${row?.amount ?? 0} ${t('SAR')}` },
    { field: 'created_at', header: t('created_at'), body: row => formatDate(row?.created_at) }
  ]

  return (
    <div>
      <PageHeader title={t('receipt_voucher_details')} backPath={'/manager/receipt/voucher'} />
      <div className='mb-3'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-3 mb-3'>
          <div><strong>{t('voucher_id')}:</strong> {receiptVoucher.id}</div>
          <div><strong>{t('voucher_type')}:</strong> {receiptVoucher.voucher_type}</div>
          <div><strong>{t('date')}:</strong> {formatDate(receiptVoucher.date)}</div>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-3 mb-3'>
          <div><strong>{t('total_amount')}:</strong> {receiptVoucher.total_amount} {t('SAR')}</div>
          <div><strong>{t('costCenter')}:</strong> {costCenterName(receiptVoucher)}</div>
        </div>
      </div>
      <CustomTable data={data} columns={viewVoucherColumns} />
      <div className='mt-4'>
        <h3 className='text-xl font-semibold mb-2'>{t('Voucher Details')}</h3>
        <CustomTable data={detailData} columns={detailColumns} />
      </div>
    </div>
  )
}
